import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-direct-debit-list-view-status',
    templateUrl: './view-status.component.html',
    styleUrls: ['./view-status.component.scss']
})
export class ViewStatusComponent {
    @Input() returnCode: number;
    arr = [1, 2, 3, 4, 5];
}
